// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__QsOQC","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1xTVU","obliqueLine":"membershipbadge_obliqueLine___P392"};